import {ReactNode} from "react";

import {Alert} from "@/components/alert/Alert.tsx";
import {AlertVariant} from "@/components/alert/Alert.types.ts";

interface InstantCheckoutContainerProps {
  message?: ReactNode;
  cta?: ReactNode;
  alertVariant?: AlertVariant;
}

export const InstantCheckoutContainer = ({message, cta, alertVariant = "error"}: InstantCheckoutContainerProps) => {
  const ctaCol = <div className="col-3 d-flex flex-column justify-content-between">{cta}</div>;
  return (
    <Alert variant={alertVariant}>
      <div className="row">
        <div className={cta ? "col-9" : "col"}>{message}</div>
        {cta ? ctaCol : false}
      </div>
    </Alert>
  );
};
